module.exports = __webpack_public_path__ + "static/media/CTLI_13-178w.abc50280.webp";